import { StorePriceDisplayType, ZeroSellPriceDisplay } from "chipply-common";
import IProductDto from "@/chipply/i-product-dto";
import IPriceDisplay from "../interface/IPriceDisplay";

export class PriceDisplayHelper {
    public getProductPriceDisplay(
        product: IProductDto,
        priceType: "starting" | "base",
        priceValue: number,
        priceDisplay: IPriceDisplay
    ): string[] {
        const priceObj = {
            starting: {
                prefix: "Starting At ",
                price: product.startingPrice,
                display: product.startingPriceDisplay,
            },
            base: {
                prefix: "",
                price: product.basePrice,
                display: product.basePriceDisplay,
            },
        }[priceType];

        if (priceValue === 0) {
            switch (product.zeroSellPriceDisplay) {
                case ZeroSellPriceDisplay.DoNotDisplay:
                    return [""];
                case ZeroSellPriceDisplay.CustomLabel:
                    return [product.zeroSellPriceLabel];
            }
        }

        // round up: 12.02 = 13, -12.02 = -13
        const pointsValue =
            priceObj.price >= 0
                ? Math.ceil(priceObj.price / priceDisplay.dollarValuePerPoint)
                : Math.floor(priceObj.price / priceDisplay.dollarValuePerPoint);

        const strategy = {
            [StorePriceDisplayType.Points]: () => [`${priceObj.prefix}${pointsValue} pts`],
            [StorePriceDisplayType.Dollars]: () => [priceObj.display],
            [StorePriceDisplayType.Both]: () => [priceObj.display, ` / ${pointsValue} pts`],
        };

        return strategy[priceDisplay.displayType]?.() || [];
    }

    public getPriceDisplay(priceValue: number, priceDisplay: IPriceDisplay, priceValueDisplay?: string) {
        if (!priceValueDisplay) {
            const valueDisplay = (Math.round(priceValue * 100) / 100).toFixed(2);
            priceValueDisplay = "$" + valueDisplay;
        }

        const priceObj = {
            price: priceValue,
            display: priceValueDisplay,
        };
        // round up: 12.02 = 13, -12.02 = -13
        const pointsValue =
            priceObj.price >= 0
                ? Math.ceil(priceObj.price / priceDisplay.dollarValuePerPoint)
                : Math.floor(priceObj.price / priceDisplay.dollarValuePerPoint);

        const strategy = {
            [StorePriceDisplayType.Points]: () => [`${pointsValue} pts`],
            [StorePriceDisplayType.Dollars]: () => [priceObj.display],
            [StorePriceDisplayType.Both]: () => [priceObj.display, ` / ${pointsValue} pts`],
        };

        return strategy[priceDisplay.displayType]?.() || [];
    }
}
